// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__23xLW","topBottomGutter":"Layout_topBottomGutter__2Ktzv"};